module.exports = __webpack_public_path__ + "static/media/gt.54173a02.jpeg";